import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { normalizeMalware } from '../../../api/normalizers'
import { MalwareSummary } from './MalwareSummary'
import { MalwareAssociations } from './MalwareAssociations'
import { MalwareDetectionNames } from './MalwareDetectionNames'
import { MalwareCapabilities } from './MalwareCapabilities'

function MalwareDetails({ malwareData, scrollRefs }) {
  const malware = useMemo(() => {
    if (!malwareData) return null
    return normalizeMalware(malwareData)
  }, [malwareData])

  if (!malware) return null

  return (
    <>
      <MalwareSummary malware={malware} />
      <MalwareAssociations malware={malware} ref={scrollRefs?.associationsList} />
      <MalwareCapabilities malware={malware} />
      <MalwareDetectionNames malware={malware} />
    </>
  )
}

export default MalwareDetails

MalwareDetails.propTypes = {
  id: PropTypes.string,
  malwareData: PropTypes.object
}
